export default {
  graphData: [],
};
